/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OTPField = styled.input`
  font-size: 24px;
  padding: 8px;
  text-align: center;
  border: none;
  border-bottom: 1.5px solid #a1a2a4;
  width: 34px;
  margin: 0 5px;
  &:focus {
    outline: none;
  }
  @media (max-width: 767px) {
    width: 20px;
  }
  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

function OTPInput({ onOTPChange }) {
  const [otp, setOTP] = React.useState(Array(6).fill(""));
  const otpInputs = Array.from({ length: 6 });

  const handleChange = (e, index) => {
    let { value } = e.target;
    value = value?.replace(/\D/g, "");
    value = value?.slice(0, 1);
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== "" && index < otpInputs.length - 1) {
      otpInputs[index + 1].focus();
    }
    const otpValue = newOTP.join("");
    onOTPChange(otpValue);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      otpInputs[index - 1].focus();
    }
  };

  return (
    <Container>
      {otpInputs.map((_, index) => (
        <OTPField
          key={index}
          type="number"
          value={otp[index]}
          maxLength={1}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(input) => (otpInputs[index] = input)}
        />
      ))}
    </Container>
  );
}

export default OTPInput;
